export function googlelogin(req) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req)
    };
    console.log('POST Login **************', requestOptions)
    return fetch('/shared/api/auth/google', requestOptions).then((response) => response.json())
}